const demo = {
  name: "Демо",
  keyName: "demo",
  definedEntries: [
    { 
      slug: "Slug",
      id: "ID секции"
    },
    {
      "title": "Заголовок",
      "subtitle": "Подзаголовок",
      _size: 500
    }
  ],

  blockKeyName: "block",
  blockKeyTitle: "Блок",
  tableColumns: {
    type: { title: "Тип блока", size: 1, values: [ 'img', 'video', 'gallery' ], default: 'img' },
    imagesCount: { title: "Кол-во картинок (для Gallery)", size: 1, active: ({ type }: any) => type === 'gallery' },
    reverse: { title: "Reverse", size: 1, values: [ 'Yes', 'No' ], default: 'No' }
  },
  row(x: number, el: { type: string, imagesCount: string, reverse: string }, push: (key: string, value: string) => void) {
    push(`media.tag`, el.type)

    if (el.type === 'img') {
      push(`media.src`, `Блок_${x}_Изображение_Путь_к_файлу`)
    }
    if (el.type === 'video') {
      push(`media.src.mp4`, `Блок_${x}_Видео_Путь_к_mp4`)
      push(`media.src.webm`, `Блок_${x}_Видео_Путь_к_webm`)
      push(`media.poster`, `Блок_${x}_Видео_Путь_к_Poster`)
      push(`media.loop`, `true`)
    }
    if (el.type === 'gallery') {
      push(`title`, `Блок_${x}_Галерея_Заголовок`)
      push(`text`, `Блок_${x}_Галерея_Текст_под_заголовком`)
      const imagesCount = parseInt(el.imagesCount as any)
      if (imagesCount) {
        push(`gallery.images.count`, imagesCount.toString())
        
        for (let i = 1; i <= Math.min(imagesCount, 50); i++) {
          push(`gallery.image.${i}.text`, `Блок_${x}_Галерея_Картинка_${i}_Текст`)
          push(`gallery.image.${i}.src`, `Блок_${x}_Галерея_Картинка_${i}_Путь_к_файлу`)
        }
      }
    }

    if (el.reverse === "Yes") {
      push(`order`, 'reverse')
    }
  }

}

export default demo